<template>
<div>
    <div style="display: flex;margin-top: 20px;"><div class="pointBlue"></div><span style="font-size: 17px;font-weight: 600;">目标化合物</span></div>
    <div style="margin-top: 20px; display: flex;">
        <div style=" width: 80%">
            <div >
       <span style="color: #9a9aaf;padding: 0 11px 0 0;">结构式名称</span><span v-if="SampleInfo.TargetName != undefined">
                            {{SampleInfo.TargetName}}
                        </span>
        </div>
        <div style=" margin-top: 35px">
            <span style="color: #9a9aaf;">CAS号</span><span v-if="SampleInfo.CAS != undefined">
                            {{SampleInfo.CAS}}
        </span>
        </div>
        </div>
        <div v-if="SampleInfo.TargetPic != undefined && SampleInfo.TargetPic != ''"  style="border: 1px solid #d5d5d5;box-sizing: border-box;"><img :src="'data:image/png;base64,'+SampleInfo.TargetPic" class="imgShow"/></div>
    </div>
    <div style="display: flex;margin-top: 20px;margin-bottom: 20px;"><div class="pointBlue"></div><span style="font-size: 17px;font-weight: 600;">起始化合物</span></div>
    <el-table :data="startObjects" border v-if="startObjects[0].png!=''||startObjects[0].name!=''||startObjects[0].cas!=''">
                    <el-table-column prop="name" label="结构式名称" align="center"></el-table-column>
                    <el-table-column label="结构式" width="400"  align="center">
                        <template slot-scope="scope">
                                <img v-if="scope.row.png != undefined && scope.row.png != ''" :src="'data:image/png;base64,'+scope.row.png" class="img-style"/>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cas" label="Cas名称"  align="center"></el-table-column>
                </el-table>
</div>
</template>

<script>
    export default {
        name: "GetOriginSample",
        data() {
          return {
          }
        },
        created() {
        },
        props: {
            SampleInfo: {},
            startObjects: {}

        }
    }
</script>

<style scoped>
    @import "../../../assets/element-component.css";
.pointBlue{
    background: #107ff1;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 6px 7px 0 0;
}
.img-style{
    width: 126px;
    border: 1px solid #c4c4c7;
    box-sizing: border-box;
    padding: 4px 0 4px 0;
}
.imgShow{
    max-width: 135px;
    max-height: 135px;
    padding: 6px 5px 1px 5px;
}
/* 使用更具体的选择器来覆盖默认样式 */
::v-deep .el-table__header-wrapper tr th {
  background-color: #EBEEF5;;
}
</style>